import { CHANNELS, FIELDS } from '../../../../shared/screener-constants';
import _flatten from 'lodash/flatten';
import _cloneDeep from 'lodash/cloneDeep';

function removeHash(string) {
  return string.replace('#', '');
}

function getSinglePlanTickers({ participantPlansAndTickers, planNumber, subPlanNumber }) {
  const filteredPlan = subPlanNumber
    ? participantPlansAndTickers.filter(
      plan => plan.planNumber === planNumber && plan.subPlanNumber === subPlanNumber
    )
    : participantPlansAndTickers.filter(plan => plan.planNumber === planNumber);
  const tickers = filteredPlan[0]?.tickers;
  return tickers;
}

export const addOwnedFundsFlag = (
  participantPlansAndTickers,
  data,
  channel,
  planNumber,
  subPlanNumber,
  bluetagcharacteristic
) => {
  let ownedResultsCount = 0;
  if (channel !== CHANNELS.MYTIAA || participantPlansAndTickers.length === 0) {
    return { data, ownedResultsCount };
  }
  /*Cloning data to avoid changing the results directly */
  data = _cloneDeep(data);
  let ownedTickers = [];

  if (planNumber) {
    // If single plan, find the plan in the api response and get those specific tickers
    ownedTickers = getSinglePlanTickers({ participantPlansAndTickers, planNumber, subPlanNumber });
  } else {
    // loop through api response and collect all tickers
    const tickersFirst = participantPlansAndTickers?.length
      ? participantPlansAndTickers
        .map(({ tickers } = {}) => {
          return tickers ? { tickers } : false;
        })
        .filter(Boolean)
      : [];

    ownedTickers = _flatten(tickersFirst.map(tickerSet => [...tickerSet.tickers]));
  }

  if (!ownedTickers) {
    return { data, ownedResultsCount };
  }

  const sanitizedTickers = ownedTickers.map(ticker => removeHash(ticker));

  for (const row of data) {
    if (
      sanitizedTickers.includes(row[FIELDS.TCDERIVEDTICKER]) ||
      sanitizedTickers.includes(row[FIELDS.TCWSODISSUE].toString())
    ) {
      row['isOwned'] = true;
      ownedResultsCount++;
    }
  }
  return { data, ownedResultsCount };
};
